import React from "react";
import { TYPE_PC } from "../../../common/defines";
import { customer_voice } from "../../../common/customer_voice";

export const premium = ({ type }) => {
  return (
    <div className="tab_panel">
      <div className="characteristic">
        <div className="title">トランクハウス24シリーズのおススメポイント</div>
        <div className="text">
          ・無料駐車場完備
          <br />
          ・1軒まるごとトランクルーム専用建築
          <br />
          ・24時間いつでも利用可能
          <br />
          ・清潔感のある外装・内装で女性の方にお勧め
          <br />
          ・安心の警備会社セキュリティ完備
          <br />
          ・部屋数も多くサイズ展開が豊富
          <br />
        </div>
      </div>
      {type === TYPE_PC ? customer_voice(type, true) : ""}
    </div>
  );
}



// WEBPACK FOOTER //
// ./pages/new/lineup/premium.jsx